import { RandomId } from "@swivl-mono/helpers";
import { NodeData_MergeUserNode, NodeData_StoreFinderLookup, NodeInterface, NodeType, VarKey } from "@swivl-mono/types";

import TabNodeLayoutData from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";

const MergeUserNode = {
  Type: NodeType.MergeUser,
  Empty: function () {
    const node = {
      id: RandomId(6),
      type: NodeType.MergeUser
    } as NodeData_MergeUserNode;

    return node; //
  },
  PlumbData: function (_node: NodeInterface) {
    const node = _node as NodeData_MergeUserNode;

    return TabNodeLayoutData({
      node: node,
      title: "Merge User",
      baseWidth: 150,
      tabs: []
    });
  },
  InspectorPanel: class InputInspectorPanel extends NodePanel {
    constructor(props) {
      super(props);
      this.filterToggled = this.filterToggled.bind(this);
    }
    filterToggled(name: string, on: boolean) {
      let node: NodeData_StoreFinderLookup = { ...this.props.node } as NodeData_StoreFinderLookup;
      node.filterStores = on;
      if (on) {
        node.filterVariableId = VarKey.UserFilterFeatures;
      } else {
        delete node.filterVariableId;
      }
      this.props.updateNode(node, this.props.node);
    }

    render() {
      const node = this.props.node as NodeData_MergeUserNode;

      return (
        <div>
          <div className="panel message_panel">
            <InspectorNodeHeader title="Merge User" />
          </div>
          <InspectorFooter deleteNode={this.deleteNode} node={node} />
        </div>
      );
    }
  }
};
export default MergeUserNode;
